import { useEffect } from "react"
import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from "react-router-dom"

import * as Sentry from "@sentry/react"

Sentry.init({
    dsn: "https://51a4e4449a65f4ac6075f6d06c931e52@o4506863888564224.ingest.us.sentry.io/4506874227261440",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        /^https:\/\/ecomoni-dashboard\.web\.app/,
        /^https:\/\/ecomoni-dashboard\.firebaseapp\.com/,
        /^https:\/\/app\.ecomoni\.nl/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
})

export const RoutesWithSentry = Sentry.withSentryReactRouterV6Routing(Routes)
